import { render, staticRenderFns } from "./KisSubjectAreaEditDialog.vue?vue&type=template&id=6202ea1a"
import script from "./KisSubjectAreaEditDialog.js?vue&type=script&lang=js&external"
export * from "./KisSubjectAreaEditDialog.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports